import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-dda {
  background-color: #DEEDF2;
  padding: 40px 0 55px;
  position: relative;
}

#renegociacao25-dda .ctn-home-24 {
  position: initial;
}

#renegociacao25-dda .dda-contain {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  position: relative;
  z-index: 2;
}

#renegociacao25-dda .dda-textos {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#renegociacao25-dda .dda-textos .dda-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
  margin: 0;
}

#renegociacao25-dda .dda-textos .dda-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
}

#renegociacao25-dda .btn-dda {
  width: 100%;
  max-width: 272px;
  height: 48px;
}

#renegociacao25-dda .ic-dda {
  mix-blend-mode: multiply;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
}


@media (min-width: 992px) {
  #renegociacao25-dda {
    padding: 48px 0;
    position: initial;
  }
  
  #renegociacao25-dda .ctn-home-24 {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }
  
  #renegociacao25-dda .dda-contain {
    gap: 32px;
    width: 857px;
    align-items: baseline;
  }
  
  #renegociacao25-dda .dda-textos {
    gap: 8px;
  }
  
  #renegociacao25-dda .dda-textos .dda-titulo {
    font-size: 40px;
    line-height: 60px;
  }
  
  #renegociacao25-dda .dda-textos .dda-texto {
    line-height: 150%;
  }
  
  #renegociacao25-dda .ic-dda {
    bottom: -48px;
    left: 0;
    transform: none;
  }
}

@media (min-width: 1280px) {
  #renegociacao25-dda .ic-dda {
    left: -45px;
  }
}`;

export default styles;